import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { TokenDisplayDialogFeature } from './token-display-dialog.feature';
import { TokenDisplayDialogEffect } from './token-display-dialog.effect';

@NgModule({
  imports: [
    TokenDisplayDialogFeature,
    EffectsModule.forFeature([ TokenDisplayDialogEffect ])
  ],
  exports: [ TokenDisplayDialogFeature ]
})
export class TokenDisplayDialogModule {}
